import { useQuery } from '@tanstack/react-query';
import { mediaListQueryOptions } from '../service/query-options';
import type { MerchantMediaListParams } from '../service/types';

export function useMediaLibraryQuery(params: MerchantMediaListParams) {
  return useQuery(mediaListQueryOptions(params));
}
